import React from 'react'
import { LazyImage } from '@babylon/medkit'
import loadImage from './loadImage'

interface Props extends React.HTMLProps<HTMLImageElement> {
  alt: string
  fallback?: string
  src: string
}

const ImageLoader = ({ src, fallback = '/', ...props }: Props) => (
  <LazyImage load={loadImage(src, fallback)} {...props} />
)

export default ImageLoader
